import { Routes } from "@/lib/routes"
import { generateSlug } from "@/utils/helpers/utils"
import { ContentNavItem, NavItem } from "@/types"
import { BiCategoryAlt } from "react-icons/bi"
import {
   FaBullhorn,
   FaCalculator,
   FaLaptopCode,
   FaLightbulb,
   FaMoneyCheckAlt,
   FaPlayCircle,
   FaRegNewspaper,
   FaChartLine,
} from "react-icons/fa"
import { GrResources } from "react-icons/gr"
import { HiOutlineChartBar, HiOutlineTemplate } from "react-icons/hi"
import { IoBusinessOutline, IoLibraryOutline } from "react-icons/io5"
import { LuClipboardList } from "react-icons/lu"
import {
   MdEvent,
   MdOndemandVideo,
   MdOutlineApps,
   MdOutlineAutoGraph,
   MdOutlineBusinessCenter,
   MdOutlineSchool,
   MdOutlineWorkOutline,
   MdPointOfSale,
} from "react-icons/md"
import { TbReportMoney, TbToolsKitchen3, TbTruckDelivery } from "react-icons/tb"
import { RiDashboardHorizontalLine } from "react-icons/ri"
import { ResourceType } from "@/app/generated/prisma"
export const resourceLinks: ContentNavItem[] = [
   {
      title: "All Resources",
      href: Routes.client.resources.getPath(),
      icon: RiDashboardHorizontalLine,
      description:
         "Read and download our full collection of expert guides, industry reports, and restaurant playbooks.",
      hideInDesktopNav: true,
   },
   {
      title: "Library",
      href: Routes.client.resourceTypePage.getPath({ resourceType: ResourceType.library, categorySlug: "" }),
      icon: IoLibraryOutline,
      description: "Library Resources for the Restaurant industry",
   },
   {
      title: "Templates",
      href: Routes.client.resourceTypePage.getPath({ resourceType: ResourceType.templates, categorySlug: "" }),
      icon: HiOutlineTemplate,
      description: "Ready to use templates and guides for the Restaurant Industry",
   },
   {
      title: "Tools",
      href: Routes.client.resourceCalculators.getPath(),
      icon: FaCalculator,
      description: "Explore our tools to optimize your restaurant operations.",
   },
   {
      title: "Industry Trends",
      href: Routes.client.resourceTypePage.getPath({ resourceType: ResourceType.industry_trends, categorySlug: "" }),
      icon: FaChartLine,
      description: "Access the latest restaurant industry benchmarks and performance insights.",
   },
   // {
   //    title: "Food Handler Certification",
   //    href: "https://foodhandler.restaurantassociation.com",

   //    icon: GrCertificate,
   //    description: "",
   // },
]
export const topicsContent: ContentNavItem[] = [
   {
      title: "All Topics",
      href: Routes.client.topics.getPath(),
      icon: RiDashboardHorizontalLine,
      description: "Latest updates and articles on Point of Sale systems for restaurants.",
      hideInDesktopNav: true,
   },
   {
      title: "Point of Sale",
      href: Routes.client.topic.getPath({ slug: "point-of-sale" }),
      icon: MdPointOfSale,
      description: "Latest updates and articles on Point of Sale systems for restaurants.",
   },
   {
      title: "Payroll",
      href: Routes.client.topic.getPath({ slug: "payroll" }),
      icon: FaMoneyCheckAlt,
      description: "Insights and news on payroll solutions tailored for the restaurant industry.",
   },
   {
      title: "Operations",
      specialNaming: "operations-blog",
      href: Routes.client.topic.getPath({ slug: "operations-blog" }),
      icon: FaMoneyCheckAlt,
      description: "Insights and news on payroll solutions tailored for the restaurant industry.",
   },
   {
      title: "Accounting",
      href: Routes.client.topic.getPath({ slug: "accounting" }),
      icon: TbReportMoney,
      description: "Stay informed with the latest accounting practices for restaurants.",
   },
   {
      title: "Back Office",
      href: Routes.client.topic.getPath({ slug: "back-office" }),
      icon: MdOutlineApps,
      description: "Discover the best back office applications to streamline restaurant operations.",
   },
   {
      title: "Marketing",
      href: Routes.client.topic.getPath({ slug: "marketing" }),
      icon: FaBullhorn,
      description: "Explore marketing strategies and tools for restaurant growth.",
   },
   {
      title: "Business Management",
      href: Routes.client.topic.getPath({ slug: "business-management" }),
      icon: MdOutlineBusinessCenter,
      description: "Updates on business management techniques for the restaurant sector.",
   },
   {
      title: "Technology",
      href: Routes.client.topic.getPath({ slug: "technology" }),
      icon: FaLaptopCode,
      description: "Stay ahead with the latest in POS systems, AI integration, and digital transformation.",
   },
]

export const generateResourceCategories = (
   databaseCategories: Array<{ id: string; name: string }>,
): ContentNavItem[] => {
   const baseLinks: ContentNavItem[] = [
      {
         title: "All Resources",
         href: "/resources",
         icon: RiDashboardHorizontalLine,
         description: "Read and download our full collection of expert guides and operational playbooks.",
      },
   ]

   const dynamicCategoryLinks = databaseCategories.map((category) => {
      const slug = category.name
         .toLowerCase()
         .replace(/[-_\s]+/g, "-")
         .trim()

      return {
         title: category.name,
         href: `/resources/${slug}`,
         icon: GrResources,
         description: `View restaurant industry documents and checklists for ${category.name}.`,
      }
   })

   return [...baseLinks, ...dynamicCategoryLinks]
}
//Point of Sale Reviews, Payroll Processing, Accounting, Back Office Apps, Marketing, Business Management
export const newsContent: ContentNavItem[] = [
   {
      title: "All News",
      href: Routes.client.newsPage.getPath(),
      icon: RiDashboardHorizontalLine,
      description: "Latest updates and articles on Point of Sale systems for restaurants.",
      hideInDesktopNav: true,
   },
   {
      title: "Tech",
      href: Routes.client.news.getPath({ slug: "tech" }),
      icon: FaLaptopCode,
      description: "Stay ahead with the latest in POS systems, AI integration, and digital transformation.",
   },
   {
      title: "Marketing Ideas",
      href: Routes.client.news.getPath({ slug: "marketing-ideas" }),
      icon: MdOutlineAutoGraph,
      description: "Creative strategies to boost your brand visibility and drive customer loyalty.",
   },
   {
      title: "Operations",
      href: Routes.client.news.getPath({ slug: "operations" }),
      icon: LuClipboardList,
      description: "Expert advice on streamlining workflows, staff management, and back-of-house efficiency.",
   },
   {
      title: "Menu Development",
      href: Routes.client.news.getPath({ slug: "menu-development" }),
      icon: TbToolsKitchen3,
      description: "Insights into culinary trends, recipe engineering, and seasonal menu planning.",
   },
   {
      title: "Delivery",
      href: Routes.client.news.getPath({ slug: "delivery" }),
      icon: TbTruckDelivery,
      description: "Optimizing your logistics, third-party partnerships, and off-premise dining experience.",
   },
   {
      title: "Franchising",
      href: Routes.client.news.getPath({ slug: "franchising" }),
      icon: IoBusinessOutline,
      description: "Resources for scaling your concept, legal updates, and multi-unit growth strategies.",
   },
   {
      title: "News",
      href: Routes.client.news.getPath({ slug: "news" }),
      icon: FaRegNewspaper,
      description: "Breaking industry headlines, market reports, and essential daily updates.",
   },
]
export const mediaContent: ContentNavItem[] = [
   {
      title: "Media Page",
      href: Routes.client.shows.getPath(),
      icon: RiDashboardHorizontalLine,
      description:
         "Watch and explore our full collection of media shows, series, and exclusive restaurant tech insights.",
      hideInDesktopNav: true,
   },
   {
      title: "Chomp Show",
      href: Routes.client.showChannel.getPath({ slug: "Chomp Show" }),
      icon: FaPlayCircle,
      description:
         "Watch our exclusive series featuring deep dives into the latest restaurant tech and industry leaders.",
   },
   {
      title: "Restaurant Tips",
      href: Routes.client.showChannel.getPath({ slug: "Restaurant Tips" }),
      icon: FaLightbulb,
      description:
         "Actionable advice and quick wins to improve your service, menu engineering, and customer experience.",
   },
   {
      title: "The Restaurant Pulse",
      href: Routes.client.showChannel.getPath({ slug: "The Restaurant Pulse" }),
      icon: HiOutlineChartBar,
      description:
         "Get the heartbeat of the industry with up-to-the-minute news, market trends, and economic insights.",
   },
]

const navigationLinks = [
   {
      title: "News",
      href: Routes.client.newsPage.getPath(),
      content: newsContent,
      icon: BiCategoryAlt,
   },
   {
      title: "Blog",
      href: Routes.client.topics.getPath(),
      content: topicsContent,
      icon: BiCategoryAlt,
   },
   {
      title: "TV Shows",
      href: Routes.client.shows.getPath(),
      content: mediaContent,
      icon: MdOndemandVideo,
   },
   {
      title: "Academy",
      href: process.env.NEXT_PUBLIC_TRAINING_BASE_URL || "https://training.restaurantassociation.com",
      icon: MdOutlineSchool,
   },
   {
      title: "Events",
      href: process.env.NEXT_PUBLIC_WEBINAR_BASE_URL || "https://webinar.restaurantassociation.com",
      icon: MdEvent,
   },
   {
      title: "Jobs",
      href: process.env.NEXT_PUBLIC_JOBS_BASE_URL || "https://jobs.restaurantassociation.com",
      icon: MdOutlineWorkOutline,
   },

   {
      title: "Resources",
      content: resourceLinks,
      href: Routes.client.resources.getPath(),
      icon: GrResources,
   },
   {
      title: "Benefits",
      href: Routes.client.benefits.getPath(),
      icon: BiCategoryAlt,
   },
] as const
// eslint-disable-next-line unused-imports/no-unused-vars
export const generateNavLinks = (
   latestVideoSlug: string,
   jobs_session?: string,
   training_session?: string,
   webinars_session?: string,
) => {
   return navigationLinks
}
export const generateFooterLinks = () => {
   const aboutLinks: NavItem[] = [
      {
         title: "About Us",
         href: Routes.client.about.getPath(),
         icon: MdOutlineAutoGraph,
      },
      {
         title: "Our Team",
         href: Routes.client.staff.getPath(),
         icon: MdOutlineAutoGraph,
      },
      {
         title: "Contact Us",
         href: Routes.client.contact.getPath(),
         icon: MdOutlineAutoGraph,
      },
   ]

   const legalLinks: NavItem[] = [
      {
         title: "Editorial Policy",
         href: Routes.client.ethics.getPath(),
         icon: MdOutlineAutoGraph,
      },
      {
         title: "Review Guidelines",
         href: Routes.client.reviewGuidelines.getPath(),
         icon: MdOutlineAutoGraph,
      },
      {
         title: "Disclosure Policy",
         href: Routes.client.disclosurePolicy.getPath(),
         icon: MdOutlineAutoGraph,
      },
      {
         title: "Privacy Policy",
         href: Routes.client.privacyPolicy.getPath(),
         icon: MdOutlineAutoGraph,
      },
      {
         title: "Terms & Conditions",
         href: Routes.client.termsAndConditions.getPath(),
         icon: MdOutlineAutoGraph,
      },
      // {
      //    title: "Leadership",
      //    href: Routes.client.termsAndConditions.getPath(),
      //    icon: MdOutlineAutoGraph,
      // },
      // {
      //    title: "Advisory Board",
      //    href: Routes.client.termsAndConditions.getPath(),
      //    icon: MdOutlineAutoGraph,
      // },
      {
         title: "Editorial Standards",
         href: Routes.client.editorialStandards.getPath(),
         icon: MdOutlineAutoGraph,
      },
      {
         title: "Code of Ethics",
         href: Routes.client.codeOfEthics.getPath(),
         icon: MdOutlineAutoGraph,
      },
      {
         title: "Membership Terms",
         href: Routes.client.membershipTerms.getPath(),
         icon: MdOutlineAutoGraph,
      },
   ]
   const footerNavLinks: NavItem[] = [
      {
         title: "Articles",
         href: Routes.client.posts.getPath(),
         icon: FaRegNewspaper,
      },
      ...navigationLinks,
   ].filter((item: NavItem) => item.title !== "Resources")
   return {
      resources: resourceLinks,
      navigation: footerNavLinks,
      about: aboutLinks,
      legal: legalLinks,
   }
}

// Slugs that mark a category as a Blog "topic" — the single source of truth for
// "is this a Blog category". `lib/article-routing.ts` imports this directly (rather
// than deriving its own copy) so the two can't drift apart the way
// `TOPICS_SLUGS`/`TOPIC_CATEGORY_SLUGS` used to.
//
// Built from each item's own title slug (the legacy identifier most stored categories
// still use, e.g. "operations") *and* its `specialNaming` slug when the nav `href` uses
// a different one (e.g. "Operations" links to "operations-blog") — a category stored
// under either form is recognized consistently everywhere this set is used.
export const TOPIC_CATEGORY_SLUGS = new Set(
   topicsContent
      .filter((item) => !item.hideInDesktopNav)
      .flatMap((item) => [generateSlug(item.title), item.specialNaming].filter((slug): slug is string => !!slug)),
)

export const AUTH_LINKS = {
   login: {
      title: "Login",
      href: Routes.client.unifiedLogin.getPath(),
   },
   signup: {
      title: "Login",
      href: Routes.client.unifiedSignup.getPath(),
   },
   success: {
      title: "Success",
      href: Routes.client.unifiedSignupSuccess.getPath(),
   },
   member_benefits: {
      title: "Member Benefits",
      href: Routes.client.unifiedSignipSucessMemberBenefits.getPath(),
   },
}
